import { useState } from 'react';

export const useForceUpdate = () => {
  // update a state to force re-render
  const [, setValue] = useState(0);
  return () => setValue(Math.random());
};
